(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["image-fragment-blur-kotlin-js"] = factory();
	else
		root["image-fragment-blur-kotlin-js"] = factory();
})(globalThis, () => {
return 